import { Injectable } from "@angular/core";
import {
  CanActivate,
  UrlTree
} from '@angular/router';
import { KeycloakService } from './keycloak.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private keycloakService: KeycloakService
  ) {}

 async canActivate(): Promise<boolean | UrlTree> {
  // Wait until Keycloak is initialized
  while (!this.keycloakService.initialized) {
    await new Promise(resolve => setTimeout(resolve, 10));
  }

  if (this.keycloakService.isLoggedIn()) {
    if (!this.keycloakService.canAccessPortal()) {
      this.keycloakService.logout();
      return false;
    }
    return true;
  }

  this.keycloakService.login();
  return false;
}
}
